import { Injectable, Req } from '@nestjs/common';
import {UserService} from '../user/user.service';
import {JwtService} from '@nestjs/jwt';
import {JwtPayload} from './jwt.payload';
import {updateUserDto, UpdateUserDto, UserDto} from '../user/dto/user.dto';
import {CreateUserDto,LoginUserDto} from '../user/dto/user.dto';
import {RegistrationStatus} from '../user/dto/registraton.dto';
import { UserStatusWiseResponseModel } from '@gtpl/shared-models/gtpl';
import { LogsService } from '../logs/logs.service';
import { BotService } from '../bot/bot.service';
@Injectable()
export class AuthService {
    
    
    constructor(private readonly userService: UserService, private readonly jwtService: JwtService, private logsService:LogsService,private botService:BotService ) {}
  async validateUser(payload: JwtPayload): Promise<UserDto> {
    const user = await this.userService.findByPayload(payload);    
    if (!user) {
        throw 'new HttpException(Invalid token, HttpStatus.UNAUTHORIZED)';    
    }    
    return user;  
  }
async register(userDto: CreateUserDto, @Req() request:Request): Promise<RegistrationStatus> {
    let status: RegistrationStatus = {
        success: true,   
        message: 'user registered',
    };
    try {
        // console.log(userDto);
        await this.userService.create(userDto);
    } catch (err) {
        status = {
            success: false,        
            message: err,
        };    
    }
    const userName=await this.userService.getUserInfo(request.headers['userid']);
      console.log('userId'+userName);
    await this.logsService.createLog(request.headers['userid'],'Created','User',userDto.employeeId,true,userDto.username);
    // this.botService.botMessage('Created User *'+userDto.username+'* by *'+userName.username+'*');
    return status;  
}
// async updateUser(userDto: updateUserDto): Promise<RegistrationStatus> {
//   let status: RegistrationStatus = {
//       success: true,   
//       message: 'user updated',
//   };
//   try {
//     await this.userService.update(userDto);
//   } catch (err) {
//       status = {
//           success: false,        
//           message: err,
//       };    
//   }
//   return status;  
// }
async login(loginUserDto: LoginUserDto): Promise<any> {    
  // find user in db    
  try{
  const user = await this.userService.findByLogin(loginUserDto);
  console.log(user);
  // generate and sign token    
   const token = this._createToken(user);
  
  return {
    // username:user.username,
    status: true,
    user_data: user, ...token,    
  };  
} catch(error){
  console.log(error);
  throw error;
}
}
private _createToken({ username }: UserDto): any {
   const user: JwtPayload = { username };    
    const accessToken = this.jwtService.sign(user); 
   console.log(accessToken);   
    return {
        expiresIn: '1h',//process.env.EXPIRESIN,
        accessToken,    
    };  
  }
  async getAllUsers():Promise<any>{
    const users=await this.userService.getAllUsers();
    return users;
  }

  async updateUser(userDto: updateUserDto, @Req() request:Request): Promise<RegistrationStatus> {
    console.log('UUUUUUUUUUUUUUU' + userDto + request.headers['userid']);
    let status: RegistrationStatus = {
        success: true,   
        message: 'user updated',
    };
    try {
        await this.userService.update(userDto);
    } catch (err) {
        status = {
            success: false,        
            message: err,
        }; 
    }
    const userName=await this.userService.getUserInfo(request.headers['userid']);
      console.log('userId'+userName);
    await this.logsService.createLog(request.headers['userid'],'Updated','User',userDto.employeeId,true,userDto.username);
    this.botService.botMessage(' User *'+userDto.username+'*  updated by *'+userName.username+'*');
    
    return status;  
  }
  async getActiveUsersCount():Promise<UserStatusWiseResponseModel>{
    const users=await this.userService.getActiveUsersCount();
    return users;
  }
}
